<template>
  <v-card class="elevation-4">
    <div class="info white--text tableHeader">
      <v-card-title>
        <h2 class="headline">{{ tableName }}</h2>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          label="Search"
          append-icon="mdi-magnify"
          dark
          color="white"
        />
        <slot name="in-title"> </slot>
      </v-card-title>
      <slot name="under-title"></slot>
    </div>
    <v-data-table
      :headers="tableHeaders"
      :items="tableData"
      :search="search"
      :disable-initial-sort="true"
      :hide-actions="hideActions"
    >
      <template slot="items" slot-scope="props">
        <td
          v-for="header in tableHeaders"
          :key="header.value"
          @click="editRow(header.value, props.item.id)"
        >
          <v-btn
            v-if="header.value === 'actions'"
            fab
            small
            color="red"
            @click="removeRow(props.item.id)"
            class="removeRowButton"
          >
            <v-icon class="white--text">mdi-minus</v-icon>
          </v-btn>
          <span v-else-if="header.format === 'checkbox'">
            <v-checkbox
              :input-value="props.item[header.value]"
              @change="header.change(props.item, !!$event)"
              class="center-checkbox"
              hide-details
            />
          </span>
          <span v-else-if="header.value === 'timestamp'">{{
            formatDate(props.item[header.value])
          }}</span>
          <span v-else-if="props.item[header.value]">{{
            props.item[header.value].name || props.item[header.value]
          }}</span>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: "PCTable",
  props: ["headers", "items", "name", "hideActions"],
  data() {
    return {
      search: "",
      tableName: this.name,
      tableHeaders: this.headers,
      tableData: this.items,
    };
  },
  methods: {
    editRow(col, id) {
      if (col != "actions") {
        this.$emit("edit", id);
      }
    },
    removeRow(id) {
      this.$emit("remove", id);
    },
    formatDate(src) {
      return new Date(src).toLocaleDateString();
    },
  },
  watch: {
    items(newVal) {
      this.tableData = newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
td:hover {
  cursor: pointer;
}

.tableHeader {
  position: relative;
}

.removeRowButton {
  width: 20px;
  height: 20px;
}

.center-checkbox::v-deep .v-input__control {
  justify-content: space-around;
}
</style>
